import * as Element from '../element/main';

declare const grecaptcha: any;
declare const browser: any;

interface Data {
  sitekey     : string;
  errorMsg   ?: string;
}
interface Dataset extends Data, DOMStringMap {}

interface Input extends Data {
  parent      : HTMLElement,
  id          : string, 
}

export interface Elm extends HTMLDivElement {
  dataset  : Dataset;
  xDelete  : () => void;
  xIsValid : () => boolean;
  // xWeight  : (weight: number) => void;
  // xSet     : (value: number) => void;
}


/**
 * Returns the base tag
 */
// export function add(data: Input): Elm {

//   const elm = 
//     !!document.getElementById(data.id) ? document.getElementById(data.id) as Elm : 
//     /*else*/                             document.createElement('div')    as Elm;
  
//   Object.assign(elm.dataset, data);
  
//   data.parent.appendChild(elm);
//   elm.id = data.id;
//   init(elm);
  
//   return elm;
// }


export function init(elm: Elm) {

  const consentCookie = getCookie('privacy-consent');
  const de = document.documentElement.lang == 'de';

  const consentDe = `
    <div class="consent-box">
      <p>Dieses Forumlar benötigt reCaptcha welches von von Google kommt. Durch das Einschalten kann Google Ihr Surf-Verhalten mitverfolgen.</p>
      <p>Mehr information dazu finden Sie in den der <a href="/de/privacy-policy">Datenschutzerklärung</a>.</p>
      <button type="button" class="recaptcha-consent-button">Einschalten</button>
    </div>
  `;

  const consentEn = `
    <div class="consent-box">
      <p>This form requires reCaptcha which comes from Google. By turning it on, Google can track your surfing behavior.</p>
      <button type="button" class="recaptcha-consent-button">Turn on</button>
      <p>More information can be found in the <a href="/en/privacy-policy">Privacy Policy</a>.</p>
    </div>
  `;

  const consentText = de ? consentDe : consentEn

  if (consentCookie == 'no') {
    const consent = Element.div({
      parent      : elm,
      id          : `${elm.id}__consent`,
      className   : 'no-consent',
      innerHTML   : consentText,
    });
    const button = elm.querySelector('.recaptcha-consent-button');
    const submitButton = document.querySelector('#contact-submit');
    button.addEventListener('click', event => {
      event.preventDefault();
      consent.classList.add('hidden');
      submitButton.classList.remove('hidden');
      recaptchaInit(elm);
    });
    submitButton.classList.add('hidden');
  }
  else {
    recaptchaInit(elm);
  }
}

function recaptchaInit(elm: Elm) {

  let script = document.createElement('script');
  script.src = 'https://www.google.com/recaptcha/api.js';
  script.async = true;
  document.head.appendChild(script);

  script.addEventListener('load', update, false);

  function update() {
    updateWidget(elm);
  }

  // Delete method
  elm.xDelete = () => {
    elm.dataset.errorMsg = '';
    // Send event for form tabs.
    const event = new CustomEvent('noError', {bubbles: true});
    elm.dispatchEvent(event);
  }

  // Validation method
  elm.xIsValid = () => {
    validate(elm);
    updateWidget(elm);
    return !(elm.dataset.errorMsg);
  }
}


function getCookie(cName) {
  const name = cName + "=";
  const cDecoded = decodeURIComponent(document.cookie);
  const cArr = cDecoded.split('; ');
  let res;
  cArr.forEach(val => {
    if (val.indexOf(name) === 0) res = val.substring(name.length);
  })
  return res
}

function validate(elm: Elm){

  const de = document.documentElement.lang == 'de';

  const errorMessage = de ? 
    'Bestätigen Sie das reCAPTCHA Feld.':
    'Confirm the reCAPTCHA field.';

  const isValid = !!grecaptcha.getResponse()

  if (isValid) {
    elm.dataset.errorMsg = '';
    const event = new CustomEvent('noError', {bubbles: true});
    elm.dispatchEvent(event);
  }
  else {
    elm.dataset.errorMsg = errorMessage;
    const event = new CustomEvent('hasError', {bubbles: true});
    elm.dispatchEvent(event);
  }
}

function updateWidget(elm: Elm) {
 
  elm.classList.add('widget');
  elm.classList.add('recaptcha-widget');
  elm.dataset.sitekey = '6LdkfKcUAAAAACPkPf6yUMcZ2yRnp7f2Fbo1OTog'

  const reCaptcha = Element.div({
    parent      : elm,
    id          : `${elm.id}__recaptcha`,
    className   : 'g-recaptcha',
  });
  reCaptcha.dataset.sitekey = '6LdkfKcUAAAAACPkPf6yUMcZ2yRnp7f2Fbo1OTog'

  const ErrorText = Element.div({
    parent      : elm,
    id          : `${elm.id}__error`,
    className   : `field-error ${elm.dataset.errorMsg ? 'has-errors' : ''}`,
    innerHTML   : elm.dataset.errorMsg,
  });

}
